export enum AdPropertyType {
  Unspecified,
  Website,
  Software,
  Mobile
}